export const EMAIL_CONFIG = {
  from: 'CloseCircle <welcome@closecircle.us>',
  subjects: {
    waitlistConfirmation: 'Welcome to CloseCircle Waitlist'
  }
} as const;